module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text2_jp_m.bd79580088fdad8967a8f8f8f3210873.png";